<template>
   <div  class="container">
       <div  class="is-size-2 top20">Group Details</div>
         <br>

       <div id="mainDiv" class="has-background-light bottom10 rightBorderColor">
           <b class="is-size-5">Name:</b>&nbsp;
          <div v-if="!renaming" class="is-inline">
               <span class="is-size-5">{{groupName}}</span>&nbsp;&nbsp;
               <button class="button is-small is-coolGreen" @click="editIt"><i class="fa fa-pen"></i> </button>
          </div>

          <div v-if="renaming" class="is-inline">
              <input class="input" style="width: 200px;height: 28px" type="text" v-model="groupName" />&nbsp;
              <button class="button is-small is-coolGreen" @click="save">SAVE</button>&nbsp;
              <button class="button is-small" @click="cancel">CANCEL</button>
          </div>
          
        </div>
       
       <div class="columns top20">
           <div class="column">
               <div class="limitWidth">
                   <div class="bottom10  is-size-5 is-inline"><b>Members:</b></div>
                   <div class="is-inline is-pulled-right"><button class="button is-size-small is-coolGreen top5" style="height:20px; width: 20px; vertical-align: bottom" @click="addMember"><b class="top-3">+</b></button></div>
                   <table width="100%" class="top20">
                        <tr v-for="(item, i) in members" :key="i" class="connectRow">
                            <td>&nbsp;{{item.fName}} {{item.lName}}</td>
                            <td align="right">
                                <button class="button is-small" @click="remove(item.id_customer)">REMOVE</button>
                            </td>
                        </tr>
                   </table>
               </div>
           </div>
           <div class="column has-background-light right10 rightBorderColor">
                <div class="bottom10  is-size-5 "><b>Shared to Group:</b></div>
                <div v-for="(item, i) in bundlesInGroup" :key="i" class="shareToGroupLabel" @click="openWindow(item.id, item.rootId)">
                    <div class="is-inline-block has-text-coolGreen handCursor  is-size-4" >&nbsp;<b>::</b></div><span class="is-size-4"><b>{{item.listName}}</b></span>
                </div>
           </div>
       </div>
       <div class="lineDivider">&nbsp;</div>
        <AZWindow ref="theWindow" v-show="windowOpen && !showMinWindow" ></AZWindow>
   </div>
</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
 import AZWindow from '../components/Window.vue'
export default{
    components: {AZWindow},
    props: ['id'],
    data: function(){
        return {
            members: {},
            groupName: '',
            permName: '',
            renaming: false,
            inited: false,
            bundlesInGroup: [],
            windowOpen: false,
            showMiniWindow: false,
        }
    },

    mounted: function(){
        var self = this

        self.worked = function (data) {
           az.addRemSpinner(false, "id", "mainDiv")
           let temp = data.r
           self.groupName = temp[0].name
           self.permName = temp[0].name

           self.members = temp.filter(e => {
               return e.id_customer != self.$root.app.userAttrs.sub
           })

            function populateBundles(){
                data.shares.forEach(e => {
                    var b = self.$root.app.bundles.find(i => {
                        return i.id == e.bundleId
                    })
                    self.bundlesInGroup.push({id: e.bundleId, listName: b.listName, rootId: b.branch[0]})
                })

                self.$root.app.closeModal()
            }

            self.bundlesInGroup = []
            setTimeout(populateBundles, 500)
          
        }
        self.noWorked = function () {
            az.addRemSpinner(false, "id", "mainDiv")
            self.$root.app.closeModal()
            self.$root.app.showModalOK({message: 'There was en error loading details'})
           
        }

        function init(){
            self.inited = true;
            az.addRemSpinner(true, "id", "mainDiv")
            self.$root.app.apiClient.get('auth/account/group/' + parseInt(self.id), {}, self.worked, self.noWorked)
        }

        if(self.$root.app.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
            init();
        });
    },

    methods: {
        remove: function(sub){
            let self = this;
            function doIt(){
                self.doRemove(sub)
            }

            this.$root.app.showModalOK({message: 'Are you sure you want to remove this member?', callBack: doIt})
        },
        doRemove: function(sub){
            let self = this
            
            function w(d){
                if(d.r == 'ok'){
                    self.members = self.members.filter(e => {
                        return e.id_customer != sub
                    })
                }
            }

            function n(){
                self.$root.app.showModalOK({message: "There was an error processing your request. Please try again or contact support."})
            }

            this.$root.app.apiClient.put('auth/account/removemember', {sub: sub}, w, n)
        },

        editIt: function(){
            this.renaming = true
        },

        cancel: function(){
             this.groupName = this.permName
            this.renaming = false
           
        },

        save: function(){

            let self = this;

            function w(d){
                if(d.r = 'ok'){
                    self.permName = self.groupName
                }
                self.renaming = false
            }

            function n(){
                 self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
                 self.renaming = false
            }

            this.$root.app.apiClient.put('auth/account/rename', {id: self.id, newName: this.groupName}, w, n)
        },

        addMember: function(){
            this.$root.app.doShowModal('ModalAddMembers', {members: this.members, groupId: parseInt(this.id), callBack: this.afterSaved})
        },

        afterSaved: function(d){

            let self = this
            self.$root.app.apiClient.get('auth/account/group/' + self.id, {}, self.worked, self.noWorked)
        },

        openWindow: function(id, rootId){
            
            this.closeWindow()

            let ind = this.$root.app.bundles.findIndex(e => {
                return e.id == id
            })  

            let rootIndex = this.$root.app.treeNoInbox.findIndex(e => {
                return e.id == rootId
            })  
            

            this.$refs.theWindow.bundleIndex = ind
            this.$refs.theWindow.rootIndex = rootId

            this.windowOpen = true
            this.showMinWindow = false
        },
        closeWindow: function(){
            this.windowOpen = false
            this.showMinWindow = false
        },
        minimizeWindow: function(){
            this.showMinWindow = true
        },
        maximizeWindow: function(){
            this.showMinWindow = false
        },
    }

}

</script>